<content class="background-color-header">
  <quote-container-header *ngIf="screenWidth > 990"></quote-container-header>
  <app-portal-header-mobile *ngIf="screenWidth <= 990" (onMenuChange)="onMenuChange()"></app-portal-header-mobile>
  <app-portal-menu-mobile *ngIf="screenWidth <= 990 && isOpenMenu"></app-portal-menu-mobile>
  <div class="site-layout portal-placeholder">
    <router-outlet></router-outlet>
  </div>
</content>